import axios from "axios";
import { authHeaderBlob, authHeaderFile, authHeaderJson } from "../auth-header.service";


const envDocumentValidate = async (documentId, uploadResult = 1) => {
    return axios.post(`/api/env/document/${documentId}/validate/${uploadResult}`, { headers: authHeaderJson() } )
};

const envBlobDocumentUpload = (url, fileName, selectedFile) => {
    return axios.put(`${url}&fileName=${fileName}`, selectedFile, { headers: authHeaderBlob(selectedFile.type) });
};

// url MUST be a hardcoded route segment — never accept user input here.
// Allowed values: 'Bulk/uploadPayload/nuevo', 'ticket/ticketAnswerDocumentadd',
// 'ticket/ticketDocumentadd', 'obligacioncumplimiento/cumplimiento/document/add',
// 'obligacioncumplimiento/cumplimiento/validacion/document/add', 'Pay/edp/documents',
// 'Contract/contractmodificationdocumentadd', 'sbBook/bookDocumentadd',
// 'SkGAP/gaprevisiondocumentadd', 'SkGAP/gapactiondocumentadd', 'skVariable/dataserievaluedocumentadd'
const envDocumentGetUrl = async (url, objectId, fileName) => {
    return axios.post(`/api/${url}/getUrl`, {id: objectId, filename: fileName}, { headers: authHeaderJson() } )
};

const envDeleteDocument = async (documentId) => {
    return axios.post(`/api/env/document/${documentId}/delete`, { headers: authHeaderJson() } )
};

const envDeactivateDocument = async (documentId) => {
    return axios.post(`/api/env/document/${documentId}/deactivate`, { headers: authHeaderJson() } )
};


export {
    envDocumentGetUrl,
    envDocumentValidate,
    envBlobDocumentUpload,
    envDeleteDocument,
    envDeactivateDocument
}